/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */
(function() {
  document.addEventListener('variant:added', function(event) {
    const detail = event && event.detail ? event.detail : {};
    const src = detail.src;
    const cart = detail.cart;
    const cartVariant = detail.variant;
    let cartData = {};

    // Klaviyo created variables
    let addedItem = window.item;
    let klaviyo = window.klaviyo || [];

    // Update Klaviyo created item price. Klaviyo injected snippet uses product
    // price which may not be the actual price of the added varaint.
    if (addedItem && cartVariant) {
      addedItem.Price = window.RS.helpers.formatMoney(cartVariant.price);
    }

    // If not on the pdp or is the main product form on the pdp and the Klaviyo
    // item object does not exist, mimic Klaviyo item object as best as possible.
    // Some properties are not available from JS Shopify object.
    if (src !== 'pdp' || ( src === 'pdp' && !addedItem)) {
      if (cartVariant) {
        addedItem = {
          Brand: cartVariant.vendor,
          ImageURL: cartVariant.image,
          Name: cartVariant.product_title,
          Price: window.RS.helpers.formatMoney(cartVariant.price),
          ProductID: cartVariant.product_id,
          URL: `${window.themeVariables.routes.secureShopUrl}${cartVariant.url}`
        }
      }
    }

    if (addedItem) {
      addedItem.src = src;
    }

    if (cart) {
      // Format from Klaviyo docs:
      // https://help.klaviyo.com/hc/en-us/articles/115001396711-Guide-to-Creating-an-Added-to-Cart-Event-for-Shopify
      cartData = {
        total_price: cart.total_price/100,
        $value: cart.total_price/100,
        total_discount: cart.total_discount,
        original_total_price: cart.original_total_price/100,
        items: cart.items
      }
    }

    klaviyo.push([
      'track',
      'Added to Cart',
      {
        ...(addedItem || {}),
        ...cartData
      }
    ])
  });

})();


/** New PDP Product image zoom featuring **/
document.addEventListener("DOMContentLoaded", function() {
  // Only run on product pages
  if (!window.location.pathname.startsWith('/products/')) {
    console.log("ℹ️ Zoom feature skipped — not a product page");
    return;
  }
  
  const toggleButton = document.querySelector(".product__zoom-button");
  if (!toggleButton) return;

  // Zoom component & its media scope
  const zoomElId = toggleButton.getAttribute("aria-controls");
  const zoomEl = document.getElementById(zoomElId);
  if (!zoomEl) return;

  // The gallery DOM ProductImageZoom will scan when building items
  const zoomMediaRoot = zoomEl.closest(".product__media");
  if (!zoomMediaRoot) return;

  // Collect all visible media tiles
  const allMediaItems = Array.from(document.querySelectorAll(".product_media_pc .product__media-item"));

  let hoveredMediaId = null;   // numeric media id from data-media-id attr
  let hoveredNonVideo = false; // track if last hover was an image

  /* ---------------------------
   * Hover logic (global list)
   * ------------------------- */
  allMediaItems.forEach(item => {
    item.addEventListener("mouseenter", () => {
      const mediaType = item.getAttribute("data-media-type");
      if (mediaType === "video") {
        hoveredNonVideo = false;
        toggleButton.style.display = "none";
        return;
      }

      hoveredNonVideo = true;
      hoveredMediaId = item.getAttribute("data-media-id");
      item.appendChild(toggleButton);
      toggleButton.style.display = "flex";
    });

    item.addEventListener("mouseleave", () => {
      toggleButton.style.display = "none";
    });
  });

  /* ------------------------------------------------
   * Click zoom => select matching media in zoom scope
   * ---------------------------------------------- */
  toggleButton.addEventListener("click", (e) => {
    e.preventDefault();
    if (!hoveredNonVideo || !hoveredMediaId) return;

    // Find matching media item inside zoom scope
    const scopedItems = Array.from(
      zoomMediaRoot.querySelectorAll('.product__media-item[data-media-type="image"]:not(.is-filtered)')
    );

    let targetItem = scopedItems.find(el => el.getAttribute("data-media-id") === hoveredMediaId);

    // Fallback: use first item if no match
    if (!targetItem) targetItem = scopedItems[0];

    // Update selection class in zoom scope
    scopedItems.forEach(el => el.classList.remove("is-selected"));
    if (targetItem) targetItem.classList.add("is-selected");

    // Close and destroy any existing PhotoSwipe instance for fresh init
    if (zoomEl.photoSwipeInstance) {
      try { zoomEl.photoSwipeInstance.close(); } catch (_e) {}
      try { zoomEl.photoSwipeInstance.destroy(); } catch (_e) {}
      zoomEl.photoSwipeInstance = null;
    }

    // Force re-open by toggling 'open' attribute
    zoomEl.removeAttribute("open");
    requestAnimationFrame(() => {
      zoomEl.setAttribute("open", "");
    });
  });

  /* ------------------------------------------------
   * Observe zoom element for close -> cleanup
   * ---------------------------------------------- */
  const observer = new MutationObserver(muts => {
    for (const m of muts) {
      if (m.attributeName === "aria-hidden") {
        const hidden = zoomEl.getAttribute("aria-hidden") === "true";
        if (hidden) {
          // Remove 'open' attribute to reset state
          zoomEl.removeAttribute("open");

          // Destroy PhotoSwipe instance reference
          if (zoomEl.photoSwipeInstance) {
            try { zoomEl.photoSwipeInstance.destroy(); } catch (_e) {}
            zoomEl.photoSwipeInstance = null;
          }

          // Reset class list to just 'pswp'
          zoomEl.className = "pswp";

          // Remove inline styles that might interfere
          zoomEl.removeAttribute("style");
        }
      }
    }
  });
  observer.observe(zoomEl, { attributes: true });
});


/* ------------------------------------------------
  * ID Kit => Removal function
  * ---------------------------------------------- */
document.addEventListener("DOMContentLoaded", () => {
  console.log("✅ custom.js loaded");

  const customProductIds = [
    54331405500489,
    54331405598793,
    41901377912905,
    41905204461641,
    41887855018057,
    41892468293705,
    41892468916297,
    41892468981833
  ];

  // ✅ Shared logic to evaluate and remove custom products
  function evaluateCart(cart) {
    if (!cart || !cart.items) {
      console.log("❌ No cart items found");
      return;
    }

    const items = cart.items;
    console.log("📦 Current cart items:", items);

    const customProducts = items.filter(item =>
      customProductIds.includes(item.id) &&
      item.properties &&
      item.properties['Jersey'] &&
      item.properties['Jersey SKU']
    );

    if (customProducts.length === 0) {
      console.log("ℹ️ No custom products found — nothing to do.");
      return;
    }

    customProducts.forEach(customProduct => {
      const kitName = customProduct.properties['Jersey'];
      const kitSku = customProduct.properties['Jersey SKU'];

      console.log("🔍 Checking custom product:");
      console.log("     Name:", kitName);
      console.log("     SKU:", kitSku);

      const matchingMainProduct = items.find(item =>
        !customProductIds.includes(item.id) &&
        item.product_title === kitName &&
        item.sku === kitSku
      );

      if (matchingMainProduct) {
        console.log("✅ Found matching main product — keeping custom product.");
      } else {
        console.log("❌ No matching main product found — removing custom product.");

        const upCartContainer = document.querySelector('#upCart #CartPopup');
        if (!upCartContainer) {
          console.warn("⚠️ UpCart container not found in DOM");
          return;
        }

        const cartItems = upCartContainer.querySelectorAll('.upcart-product-item');        
        for (const item of cartItems) {
          const properties = {};
          const propertyElements = item.querySelectorAll('.upcart-item-property');
          propertyElements.forEach(prop => {
            const strongElement = prop.querySelector('strong');
            const spanElement = prop.querySelector('span');
            if (strongElement && spanElement) {
              const key = strongElement.textContent.replace(':', '').trim();
              const value = spanElement.textContent.trim();
              properties[key] = value;
            }
          });

          const itemJerseyName = properties.Jersey;
          const itemJerseySku = properties['Jersey SKU'];

          if (itemJerseyName === kitName && itemJerseySku === kitSku) {
            console.log('🎯 Found matching custom product in UpCart UI by Jersey/SKU match');

            const trashButton = item.querySelector('.styles_TrashButton__deleteButton__');
            if (trashButton) {
              trashButton.click();
              break; // Stop looking for more — this one is removed
            }
          }
        }
      }
    });
  }

  // ✅ Listen to cart:refresh when available
  document.documentElement.addEventListener("cart:refresh", (event) => {
    console.log("🟢 cart:refresh triggered");
    evaluateCart(event.detail.cart);
  });

  // ✅ Observe <cart-drawer> for DOM changes (fallback)
  const observeCartDrawerChanges = () => {
    const cartDrawer = document.querySelector("cart-drawer");
    if (!cartDrawer) {
      console.warn("🛑 <cart-drawer> element not found");
      return;
    }

    const observer = new MutationObserver(() => {
      console.log("👀 Detected changes in <cart-drawer> — fetching cart data...");
      fetch("/cart.js")
        .then(res => res.json())
        .then(cart => evaluateCart(cart))
        .catch(err => console.error("⚠️ Failed to fetch cart after mutation:", err));
    });

    observer.observe(cartDrawer, {
      childList: true,
      subtree: true
    });

    console.log("👁️ MutationObserver is now watching <cart-drawer>");
  };

  // Wait until <cart-drawer> is available in DOM
  const waitForCartDrawer = setInterval(() => {
    if (document.querySelector("cart-drawer")) {
      clearInterval(waitForCartDrawer);
      observeCartDrawerChanges();
    }
  }, 250);
});

